@if(video){
<video #videoElement [poster]="video.cover" (ended)="onVideoEnd()" [attr.controls]="!showPlayButton ? true : null">
  <source [src]="video.url" type="video/mp4">
</video>

@if(showPlayButton){
<button class="btn btn-light play" (click)="togglePlay()">
  <div class="play-button"></div>
</button>
}
}
